import AxL from "./axl";
export default class Tracking {
  constructor(axl) {
    this.axl = axl;
    this.trackingEvents = {
      UI_TOGGLE: { eventName: "toggle_ui", NI: false, value: 0 },
      TAG_CLICKED: { eventName: "tag_click", NI: false, value: 0 },
      HOME_CLICKED: { eventName: "home_click", NI: false, value: 0 },
      SEARCH_TAG: { eventName: "search_tag_click", NI: false, value: 0 },
      SEARCH: { eventName: "search", NI: false, value: 0 },
      SHARE: { eventName: "share", NI: false, value: 0 },
      BOOKMARK_REMOVE: { eventName: "bookmark_remove", NI: false, value: 0 },
      BOOKMARK_ADD: { eventName: "bookmark_add", NI: false, value: 0 },
    };
  }
  track(event, value = null) {
    if (this.axl) {
      const param = {
        action: this.trackingEvents[event].eventName,
        value: this.trackingEvents[event].value,
        nonInteraction: this.trackingEvents[event].NI,
      };
      if (value) param["label"] = value;
      this.axl.sendMessage(AxL.ChildToHost.TRACK, param);
    } else {
      console.log("AXL IS NOT AVAILABLE FOR TRACKING");
    }
  }
}
